/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CmsConfig,
  FeaturesConfigModule,
  I18nModule,
  provideConfig
} from '@spartacus/core';
import { ProductImageZoomProductImagesComponent } from '@spartacus/product/image-zoom/components';
import {
  DIALOG_TYPE,
  IconModule,
  KeyboardFocusModule,
  LayoutConfig,
  MediaModule,
  OutletModule
} from '@spartacus/storefront';
import { CustomIconsModule } from 'src/app/custom/icons/custom-icons.module';
import { CustomCarouselModule } from '../../../shared/components/custom-carousel/custom-carousel.module';
import { CustomProductImageZoomDialogComponent } from './custom-product-image-zoom-dialog/custom-product-image-zoom-dialog.component';
import { CustomProductImageZoomThumbnailsComponent } from './custom-product-image-zoom-thumbnails/custom-product-image-zoom-thumbnails.component';
import { CustomProductImageZoomTriggerModule } from './custom-product-image-zoom-trigger/custom-product-image-zoom-trigger.module';
import { CustomProductImageZoomViewComponent } from './custom-product-image-zoom-view/custom-product-image-zoom-view.component';

@NgModule({
  imports: [
    CustomCarouselModule,
    CommonModule,
    I18nModule,
    IconModule,
    CustomIconsModule,
    KeyboardFocusModule,
    MediaModule,
    OutletModule,
    RouterModule,
    FeaturesConfigModule,
    CustomProductImageZoomTriggerModule
  ],
  providers: [
    provideConfig(<LayoutConfig>{
      launch: {
        PRODUCT_IMAGE_ZOOM: {
          inline: true,
          component: CustomProductImageZoomDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductImagesComponent: {
          component: ProductImageZoomProductImagesComponent,
        },
        ProductImageZoomViewComponent: {
          component: CustomProductImageZoomViewComponent
        },
        ProductImagesZoomThumbnails: {
          component: CustomProductImageZoomThumbnailsComponent,
        },
      },
    }),
  ],
  declarations: [
    CustomProductImageZoomDialogComponent,
    CustomProductImageZoomThumbnailsComponent,
    CustomProductImageZoomViewComponent,
  ],
  exports: [
    CustomProductImageZoomDialogComponent,
    CustomProductImageZoomThumbnailsComponent,
    CustomProductImageZoomViewComponent,
  ],
})
export class CustomProductImageZoomModule { }
